import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';
import { GeoFeatures } from './GeoFeatures';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetGeoFeaturesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGeoFeaturesQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string, geoBasedFeatures?: { __typename?: 'GeoBasedFeatures', canToggleSpeakerDiarization?: boolean | null } | null } | { __typename?: 'IdentifiedUser' } | null };


export const GetGeoFeatures = /*#__PURE__*/ gql`
    query GetGeoFeatures {
  me {
    ...GeoFeatures
  }
}
    ${GeoFeatures}` as unknown as DocumentNode<GetGeoFeaturesQuery, GetGeoFeaturesQueryVariables>;

          

          export const useGetGeoFeaturesQuery = (options?:QueryHookOptions<GetGeoFeaturesQuery, GetGeoFeaturesQueryVariables>) => useQuery(GetGeoFeatures, options);

          

          export type GetGeoFeaturesQueryOptions = QueryHookOptions<GetGeoFeaturesQuery, GetGeoFeaturesQueryVariables>;

          

          export const useGetGeoFeaturesLazyQuery = (options?:LazyQueryHookOptions<GetGeoFeaturesQuery, GetGeoFeaturesQueryVariables>) => useLazyQuery(GetGeoFeatures, options);

          

          export type GetGeoFeaturesQueryResult = ReturnType<typeof useGetGeoFeaturesQuery>;

          
